import { render, staticRenderFns } from "./bgInDetail.vue?vue&type=template&id=112d516a&scoped=true&"
import script from "./bgInDetail.vue?vue&type=script&lang=js&"
export * from "./bgInDetail.vue?vue&type=script&lang=js&"
import style0 from "./bgInDetail.vue?vue&type=style&index=0&id=112d516a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "112d516a",
  null
  
)

export default component.exports